// src/utils/context/themeContext.tsx
import { createContext, useState, useContext, ReactNode, useEffect } from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { Theme } from '../../styles/themes/types';
import { DarkTheme } from '../../styles/themes/dark';
import { LightTheme } from '../../styles/themes/light';
import { _UserData } from '../../infra/storage/localStorage';

interface ThemeContextProps {
  theme: Theme;
  toggleTheme: () => void;
}

const ThemeContext = createContext<ThemeContextProps | undefined>(undefined);

interface ThemeProviderProps {
  children: ReactNode;
}

export function ThemeProvider ({ children }: ThemeProviderProps) {
  const [theme, setTheme] = useState<Theme>(() => {
    const savedTheme = _UserData.GetOtherData<string>('theme');
    return savedTheme === 'dark' ? DarkTheme : LightTheme;
  });

  useEffect(() => {
    _UserData.SetOtherData('theme', theme.title);
  }, [theme]);

  function toggleTheme() {
    setTheme(prevTheme => prevTheme.title === 'light' ? DarkTheme : LightTheme);
  }

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      <StyledThemeProvider theme={theme}>
        {children}
      </StyledThemeProvider>
    </ThemeContext.Provider>
  );
}

export function useTheme(): ThemeContextProps  {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}
